import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import { Checkbox } from '@material-ui/core';

const Container = styled.div`
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  display: flex;
  align-items: center;
  padding: ${rhythm(0.25)} 0;
  flex: 0 0 50%;
`;

const Desc = styled.div`
  font-size: 0.875rem;
  margin-left: ${rhythm(0.5)};
`;

const CustomCheckbox = styled(Checkbox)`
  &&& {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

const CheckboxContainer = styled.div`
  text-align: right;
`;

class SettingsItem extends React.PureComponent {
  render() {
    const { desc, onChange, name, checked, value, handleBlur } = this.props;
    return (
      <Container>
        <CheckboxContainer>
          <CustomCheckbox
            disableRipple
            checked={checked}
            onChange={onChange}
            onBlur={handleBlur}
            value={value}
            name={name}
          />
        </CheckboxContainer>
        <Desc>{desc}</Desc>
      </Container>
    );
  }
}

export default SettingsItem;
